/* Coria · text care se scrie singur in campurile de cautare (telefon + calculator).
   Scrie si sterge pe rand cateva cautari populare in placeholder.
   Merge si cand campul e activ dar gol; se opreste cand clienta scrie ceva sau cand alt script (microfonul) schimba placeholder-ul. */
(function () {
  if (window.cfSearchTyping) return;
  window.cfSearchTyping = 1;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PRE = 'Cauta ';
  var TERMS = ['oja semipermanenta', 'rubber base', 'top coat', 'lampa UV/LED', 'cat eye', 'builder gel', 'polygel', 'freza electrica', 'nuanta preferata'];
  var SEL = 'input[type="search"], input[name="q"]';
  var state = new WeakMap();

  function idle(inp) {
    return !inp.value && inp.offsetWidth > 0;
  }

  function tick(inp) {
    var s = state.get(inp);
    if (!s) return;
    // alt script a schimbat textul (ex. „Te ascult...”): asteptam sa revina
    if (s.last !== null && inp.placeholder !== s.last) { s.t = setTimeout(function () { s.last = inp.placeholder === s.orig ? null : s.last; tick(inp); }, 800); return; }
    if (!idle(inp)) {
      if (s.last !== null && inp.value) { inp.placeholder = s.orig; s.last = inp.placeholder; }
      s.t = setTimeout(function () { tick(inp); }, 600);
      return;
    }
    var word = TERMS[s.i % TERMS.length], delay;
    if (!s.del) {
      s.n++;
      if (s.n >= word.length) { s.n = word.length; s.del = true; delay = 1700; } else delay = 65 + Math.random() * 45;
    } else {
      s.n--;
      if (s.n <= 0) { s.n = 0; s.del = false; s.i++; delay = 350; } else delay = 30;
    }
    inp.placeholder = PRE + word.slice(0, s.n);
    s.last = inp.placeholder;
    s.t = setTimeout(function () { tick(inp); }, delay);
  }

  function attach(inp) {
    if (state.has(inp)) return;
    var s = { orig: inp.placeholder || 'Cauta', i: Math.floor(Math.random() * TERMS.length), n: 0, del: false, last: null, t: 0 };
    state.set(inp, s);
    inp.setAttribute('aria-label', inp.getAttribute('aria-label') || 'Cauta');
    tick(inp);
  }

  function scan() { document.querySelectorAll(SEL).forEach(attach); }
  function start() {
    scan();
    new MutationObserver(function () { clearTimeout(start.m); start.m = setTimeout(scan, 300); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
